import { useCallback } from 'react';
import { getIn } from 'formik';

import { FCheckbox } from '../../../components/baseV2';
import { useFormReadOnly } from './formReadOnlyProvider';

import type { FocusEvent, ChangeEvent } from 'react';
import type { FormikValues } from 'formik';
import type { FormCheckboxFieldProps } from '../types';

export default function FormCheckboxField<TValues extends FormikValues>({
  formik,
  name,
  label,
  disabled = false,
  readOnly = false,
  onBlur,
  onChange,
}: FormCheckboxFieldProps<TValues>) {
  const readOnlyFromContext = useFormReadOnly();
  const fieldError = getIn(formik.errors, name);
  const isTouched = Boolean(getIn(formik.touched, name));
  const helperText = isTouched ? fieldError?.toString() : undefined;

  const handleBlur = useCallback(
    (event: FocusEvent<HTMLButtonElement>) => {
      formik.handleBlur(event);
      onBlur?.(name);
    },
    [formik, name, onBlur],
  );
  const handleChange = useCallback(
    (_event: ChangeEvent<HTMLInputElement>, checked: boolean) => {
      formik.setFieldValue(name, checked);

      onChange?.(name, checked);
    },
    [formik, name, onChange],
  );

  return (
    <FCheckbox
      checked={Boolean(getIn(formik.values, name))}
      disabled={disabled || readOnly || readOnlyFromContext}
      error={Boolean(helperText)}
      helperText={helperText}
      label={label}
      name={name}
      onBlur={handleBlur}
      onChange={handleChange}
    />
  );
}
